import { render, staticRenderFns } from "./StrapiAgendaComponent.vue?vue&type=template&id=6997e72c"
import script from "./StrapiAgendaComponent.vue?vue&type=script&lang=js"
export * from "./StrapiAgendaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports